<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.1665 17.4987H5.83317C4.91234 17.4987 4.1665 16.7529 4.1665 15.832V9.9987C4.1665 9.07786 4.91234 8.33203 5.83317 8.33203H14.1665C15.0873 8.33203 15.8332 9.07786 15.8332 9.9987V15.832C15.8332 16.7529 15.0873 17.4987 14.1665 17.4987Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.6665 8.33333V5.83333V5.83333C6.6665 3.9925 8.159 2.5 9.99984 2.5V2.5C11.8407 2.5 13.3332 3.9925 13.3332 5.83333V5.83333V8.33333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
